import React from 'react'
import { ResponsiveObject, Settings } from "react-slick";
import { breakpointsMax } from "../breakpoints";
import { Breakpoint } from "../models";
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

type ResponsiveConfig = Partial<Record<Breakpoint, number>>

const DEFAULT_RESPONSIVE_CONFIG: ResponsiveConfig = {
    xxs: 1, // 0 - 424
    xs: 1, // 425 - 639
    sm: 2, // 640 - 767
    md: 3, // 768 - 1023
}

type getSliderConfig = (settings?: Omit<Settings, 'reponsive'>, responsive?: ResponsiveConfig, responsiveSettings?: Settings) => Settings

interface IArrowProps {
    onClick?: React.MouseEventHandler<HTMLButtonElement>,
    title?: string
}

const PrevArrow = ({onClick, title}: IArrowProps) => <button type="button" data-role="none" className="slick-arrow slick-prev" onClick={onClick} style={{display: "block"}}>{title ?? 'Indietro'}</button>
const NextArrow = ({onClick, title}: IArrowProps) => <button type="button" data-role="none" className="slick-arrow slick-next" onClick={onClick} style={{display: "block"}}>{title ?? 'Avanti'}</button>

export const getSliderConfig: getSliderConfig = (settings = {}, responsiveConfig = DEFAULT_RESPONSIVE_CONFIG, responsiveSettings = {}) => ({
    ...settings,
    accessibility: true,
    customPaging: settings.customPaging ? settings.customPaging : (i) => (
      <button>
        {`Vai alla slide ${i + 1}`}
      </button>
    ),
    prevArrow: settings.prevArrow ? settings.prevArrow : <PrevArrow />,
    nextArrow: settings.nextArrow ? settings.nextArrow : <NextArrow />,
    slidesToShow: settings.slidesToShow || 4,
    arrows: settings.arrows === undefined ? true : settings.arrows,
    dots: settings.dots === undefined ? true : settings.dots,
    centerMode: settings.centerMode === undefined ? false : settings.centerMode,
    infinite: settings.infinite === undefined ? false : settings.infinite,
    responsive: Object.entries(responsiveConfig).map(([breakpoint, value]) => {
        const responsiveObject: ResponsiveObject = {
            breakpoint: breakpointsMax[breakpoint as Breakpoint],
            settings: {
                ...responsiveSettings,
                slidesToShow: responsiveSettings.slidesToShow ? responsiveSettings.slidesToShow : value,
                arrows: !!responsiveSettings.arrows,
            }
        }
        if (breakpoint === 'sm' || breakpoint === 'xs' || breakpoint === 'xxs') {

            (responsiveObject.settings as Settings).arrows = false;
            (responsiveObject.settings as Settings).centerMode = false;
            (responsiveObject.settings as Settings).infinite =  settings.infinite === undefined ? false : settings.infinite;
        }

        return responsiveObject
    })
})


export const SLIDER_1X: Settings = getSliderConfig({ slidesToShow: 1 }, {})
export const SLIDER_2X: Settings = getSliderConfig({ slidesToShow: 2 })
export const SLIDER_3X: Settings = getSliderConfig({ slidesToShow: 3 })
export const SLIDER_4X: Settings = getSliderConfig({ slidesToShow: 4 })
